<template>
  <mt-popup v-model="isShowPicker" class="refund-picker" position="bottom">
    <div class="refund-picker__title">{{ headerTitle }}</div>
    <div class="refund-picker__content scroll-touch">
      <p v-for="(item, index) in option" :key="index">
        <span>{{ item.title }}</span>
        <i :class="['icon',nowKey===item.value?'selected':'not_selected',]" @click="nowKey=item.value"></i>
      </p>
    </div>
    <div class="refund-picker__button">
      <button @click="confirm">保存</button>
    </div>
  </mt-popup>
</template>
<script>
import _ from 'lodash';

export default {
  props: ['isShow', 'defaultKey', 'headerTitle', 'option'],
  data() {
    return {
      isShowPicker: false,
      nowKey: '',
      nowTitle: '',
    };
  },
  watch: {
    isShow: {
      handler(val) {
        this.isShowPicker = _.cloneDeep(val);
        this.nowKey = _.cloneDeep(this.defaultKey);
      },
      immediate: true,
    },
    nowKey: {
      handler(val) {
        const arr = this.option.filter(f => f.value === val);
        this.nowTitle = arr.length ? arr[0].title : '';
      },
      immediate: true,
    },
    isShowPicker: {
      handler(val) {
        this.$emit('changeVisible', val);
      },
      immediate: true,
    },
  },
  methods: {
    confirm() {
      const { nowKey, nowTitle } = this;
      if (nowKey === '' || nowKey === null) {
        this.$toast({ message: '请选择内容' });
        return;
      }
      this.$emit('confirm', { key: nowKey, title: nowTitle });
    },
  },
};
</script>

<style lang="scss">
.refund-picker {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  top: 30%;
  display: flex;
  flex-direction: column;

  &__title {
    font-size: 30px;
    color: #000000;
    height: 90px;
    line-height: 90px;
    text-align: center;
    border-bottom: 2px solid rgba(211, 211, 211, 0.5);
  }

  &__content {
    padding: 30px 15px 100px 15px;
    flex: 1;

    p {
      font-size: 26px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 60px;
    }
  }

  &__button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 36px;
    background: #fff;
    z-index: 100000;

    button {
      padding: 20px 0;
      width: 100%;
      font-size: 30px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 12px;
    }
  }
}
</style>
